import React from 'react';

import DayOfBirth from '@pages/SIO/BasicDetails/components/DayOfBirth/DayOfBirth';
import Modal from '@components/Modal';
import Dropdown from '@components/Dropdown';
import Bullet from '@components/Bullet';
import Button from '@components/Button';
import Input from '@components/Input';
import Heading from '@components/Heading';
import RadioButtonGroup from '@components/RadioButtonGroup';
import RadioButton from '@components/RadioButton';

export interface AddMyInfoProps {
  show: boolean;
  onClose: () => void;
  onChange: (e: any) => void;
  onSubmit: () => void;
  valid: boolean;
  values: any;
  errors: any;
  salutations: any[];
  nationlaities: any[];
  races: any[];
  maritalStatus: any[]
}

function AddMyInfo({ show, onClose, onChange, valid, values, errors, salutations, onSubmit, nationlaities, races, maritalStatus }: AddMyInfoProps) {
  return (
    <Modal show={show} onClose={onClose}>
      <Heading variant={"sub"}>Add MyInfo</Heading>
    
      <Heading margin="0 0 5px" variant="label" >NRIC*</Heading>
      {!errors?.uinfin?.isValid && errors?.uinfin?.message && (<Bullet variant="error">{errors?.uinfin?.message}</Bullet>)}
      <Input margin="0 0 10px" name="uinfin" maxLength={24} value={values["uinfin"]} onChange={onChange}></Input>

      <Heading margin="0 0 5px" variant="label">Full Name (as per NRIC)*</Heading>
      {!errors?.name?.isValid && errors?.name?.message && (<Bullet variant="error">{errors?.name?.message}</Bullet>)}
      <Input margin="0 0 10px" name="name" maxLength={40} value={values["name"]} onChange={onChange}></Input>

      <Heading margin="0 0 5px" variant="label">Given Name*</Heading>
      {!errors?.givenName?.isValid && errors?.givenName?.message && (<Bullet variant="error">{errors?.givenName?.message}</Bullet>)}
      <Input margin="0 0 10px" name="givenName" value={values["givenName"]} maxLength={40} onChange={onChange}></Input>

      <Heading margin="0 0 5px" variant="label">Family Name*</Heading>
      {!errors?.familyName?.isValid && errors?.familyName?.message && (<Bullet variant="error">{errors?.familyName?.message}</Bullet>)}
      <Input margin="0 0 10px" name="familyName" value={values["familyName"]} maxLength={40} onChange={onChange}></Input>

      <Heading margin="0 0 5px" variant="label">Salutation*</Heading>
      <Dropdown source={salutations} bindLabel="description" bindId="code" name="salutation" value={values["salutation"]} onChange={onChange} placeholder="Please select" />

      <Heading margin="0 0 5px" variant="label">Gender*</Heading>
      <RadioButtonGroup value={values['sex']} margin="0 0 10px" name="sex" onChange={onChange}>
        <RadioButton text="Male" value='M' />
        <RadioButton text="Female" value='F' />
      </RadioButtonGroup>

      <Heading margin="0 0 5px" variant="label">Race*</Heading>
      <Dropdown margin="0 0 10px" source={races} bindLabel="description" bindId="code" name="race" value={values["race"]} onChange={onChange} placeholder="Please select" />
      {values['race'] === 'others' && (<React.Fragment>
        <Heading margin="0 0 5px" variant="label">Others</Heading>
        {!errors?.otherRace?.isValid && errors?.otherRace?.message && (<Bullet variant="error">{errors?.otherRace?.message}</Bullet>)}
        <Input margin="0 0 10px" name="otherRace" value={values["otherRace"]} maxLength={50} onChange={onChange}></Input>
      </React.Fragment>)}

      <Heading margin="0 0 5px" variant="label">Nationality*</Heading>
      <Dropdown placeholder="Nationality" variant="auto-complete" margin="0 0 10px" value={values['nationality']} name="nationality" onChange={onChange} source={nationlaities} bindId='code' bindLabel='description' />

      <Heading margin="0 0 5px" variant="label">Date of birth*</Heading>
      {!errors?.dob?.isValid && errors?.dob?.message && (<Bullet variant="error">{errors?.dob?.message}</Bullet>)}
      <DayOfBirth name="dob" value={values["dob"]} onChange={onChange} error={errors?.dob?.message} />

      <Heading margin="0 0 5px" variant="label">Marital Status*</Heading>
      <Dropdown margin="0 0 10px" source={maritalStatus} bindLabel="description" bindId="code" name="marital" value={values["marital"]} onChange={onChange} placeholder="Please select" />

      <Heading margin="0 0 5px" variant="label">Mobile number*</Heading>
      {!errors?.mobileno?.isValid && errors?.mobileno?.message && (<Bullet variant="error">{errors?.mobileno?.message}</Bullet>)}
      <Input margin="0 0 10px" name="mobileno" maxLength={8} value={values["mobileno"]} onChange={onChange}></Input>

      <Heading margin="0 0 5px" variant="label">Email*</Heading>
      {!errors?.email?.isValid && errors?.email?.message && (<Bullet variant="error">{errors?.email?.message}</Bullet>)}
      <Input margin="0 0 10px" name="email" maxLength={50} value={values["email"]} onChange={onChange}></Input>

      <Heading margin="0 0 5px" variant="label">Postcode*</Heading>
      {!errors?.postal?.isValid && errors?.postal?.message && (<Bullet variant="error">{errors?.postal?.message}</Bullet>)}
      <Input margin="0 0 10px" name="postal" type="numeric" maxLength={10} value={values["postal"]} onChange={onChange}></Input>

      <Heading margin="0 0 5px" variant="label">Block*</Heading>
      {!errors?.block?.isValid && errors?.block?.message && (<Bullet variant="error">{errors?.block?.message}</Bullet>)}
      <Input margin="0 0 10px" name="block" value={values["block"]} maxLength={30} onChange={onChange}></Input>

      <Heading margin="0 0 5px" variant="label">Unit*</Heading>
      {!errors?.unit?.isValid && errors?.unit?.message && (<Bullet variant="error">{errors?.unit?.message}</Bullet>)}
      <Input margin="0 0 10px" name="unit" value={values["unit"]} maxLength={30} placeholder="e.g. #12-456" onChange={onChange}></Input>

      <Heading margin="0 0 5px" variant="label">Street name*</Heading>
      {!errors?.street?.isValid && errors?.street?.message && (<Bullet variant="error">{errors?.street?.message}</Bullet>)}
      <Input margin="0 0 10px" name="street" value={values["street"]} maxLength={30} onChange={onChange}></Input>

      <Heading margin="0 0 5px" variant="label">Building name(if any)</Heading>
      {!errors?.building?.isValid && errors?.building?.message && (<Bullet variant="error">{errors?.building?.message}</Bullet>)}
      <Input margin="0 0 10px" name="building" value={values["building"]} maxLength={30} onChange={onChange}></Input>

      <Button label="Add MyInfo" disabled={!valid} onClick={onSubmit} />
    </Modal>

  );
};

export default AddMyInfo;
